import { AbstractPmsApiService } from "./abstract.service";
import { CustomField } from "../models";

/**
 * @class CustomFieldPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<CustomField>}
 */
export class CustomFieldPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/custom-field(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {CustomField}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new CustomField(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<CustomField>>}
     */
    get (params = {}, property = null) {
        
        const url = this.url({propertyId: property ? property.id : 0});
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {CustomField} customField
     * @param {Property} property
     * @returns {Promise.<CustomField>}
     */
    create(customField, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url, customField.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {CustomField} customField
     * @returns {Promise.<CustomField>}
     */
    update(customField) {
        
        const url = this.url({
            propertyId: customField.property.id,
            id:         customField.id
        });
        
        return this.http
                   .put(url, customField.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {CustomField} customField
     * @returns {Promise.<boolean>}
     */
    delete(customField) {
        
        const url = this.url({
            propertyId: customField.property.id,
            id:         customField.id
        });
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {CustomField} customField
     * @returns {Promise.<boolean>}
     */
    moveUp(customField) {
        
        const url = this.url({
            propertyId: customField.property.id,
            id: customField.id
        });
        
        return this.http
            .get(url + '/up', {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {CustomField} customField
     * @returns {Promise.<boolean>}
     */
    moveDown(customField) {
        
        const url = this.url({
            propertyId: customField.property.id,
            id: customField.id
        });
        
        return this.http
            .get(url + '/down', {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/custom-field.service.js